import {
  pipe, flatten, pluck, reject, either, isNil, isEmpty
} from 'ramda'

import { flatMap } from 'lodash-es'
import { isMobile } from 'react-device-detect';

export const getIdsFromAlertData = (objData: Record<string, any>) => {
  const result = {};
  Object.keys(objData).forEach((key) => {
    const value = objData[key];
    if (value && key.includes("ids")) {
      key = key.replace("ids", "id");
      result[key] = value;
    }
  });

  return result;
};

// 将一个 MainJobFunction 扩展成 对应的main_functions、job_functions、function_titles
export const getJobFunctionAndJobTitles = pipe(
  pluck('sub_function_list'),     // 提取每个对象中的 sub_function_list
  flatten,                        // 将多个 sub_function_list 数组合并成一个数组
  subFunctions => ({
    subFunctions,                 // 返回所有 sub_function_list
    jobTitles: pipe(
      pluck('job_titles'),        // 提取每个 sub_function_list 中的 job_titles
      flatten                     // 将多个 job_titles 数组合并成一个数组
    )(subFunctions as any)
  })
);

const cleanData = reject(either(isNil, isEmpty));

export const seoValueParamsChangeIds = (config, searchValues) => {
  if (!config || !searchValues) return

  // functionTitles 因为seo_value有重复的，需要在重新过滤一遍
  const functionTitles = filterFunctionTitles(
    (searchValues.function_job_title ?? "").split(","),
    config.main_function_filter
  )

  const { subFunctions: jobFunctionList, jobTitles: functionsTitleList } = getJobFunctionAndJobTitles(config.main_function_filter)
  const locationLists = flatMap(config.location_filter, item => item.locations)
  const queryFields = searchValues?.queryFields?.join(',') || "job_title,company_name"
  const data = {
    query: searchValues.query,
    query_fields: queryFields === 'company' ? 'company_name' : queryFields,
    job_location_ids: (searchValues.location?.split(",") ?? []).map?.(key => locationLists.find(item => item?.['seo_value'] === key)?.id).join(',') ?? undefined,
    job_function_ids: (searchValues?.jobFunctions?.split(",") ?? []).map?.(seo => jobFunctionList.find(item => item.seo_value === seo)?.id)?.join?.(',') ?? undefined,
    function_job_title_ids: (functionTitles?.split(",") ?? []).map?.(seo => functionsTitleList.find(item => item.seo_value === seo)?.id)
      ?.join?.(',') ?? undefined,
    language_ids: searchValues.language,
    page: searchValues?.page ?? 1,
    size: searchValues?.size ?? 15,
    source: isMobile ? "mobile_web" : "web",
    sort: searchValues?.sort || '2',
  }
  return cleanData(data)
}

export const filterFunctionTitles = (function_job_title = [], main_function_filter = []) => {
  const toSeo = (value) => value?.replaceAll('/', '-')?.replaceAll(' ', '-')?.toLowerCase();
  const { jobTitles: functionsTitleList } = getJobFunctionAndJobTitles(main_function_filter)
  const newJobTitles = function_job_title.map(item => {
    const matchedChild = functionsTitleList.find(child => {
      let name = toSeo(child['seo_value']) + '-' + child.id;
      return name == item;
    });

    return matchedChild ? matchedChild['seo_value'] : null;
  }).filter(Boolean);

  return (newJobTitles ?? []).join(",")
}
